<div class="virtual-scroll-overlay" *ngIf="overlays">
    <cdk-virtual-scroll-viewport orientation="horizontal" itemSize="5" class="viewport">
        <!-- first column for fields displaying -->
        <div class="fields-header short">
            <!-- empty cell in 1st row and 1st column -->
            <div class="sticky flex center align-center">Overlays</div>

            <div class="list-wrap">
                <ng-container *ngFor="let typology of typologies">
                    <div class="item flex align-center typology-row-header">
                        <div class="cell section flex align-center">
                            <cut-down-content length="30">{{typology.Name}}</cut-down-content>
                        </div>
                        <calibration-set-attributes [identifiers]="getTypologyIdentifier(typology)"
                        [attributePopupTitleDetails]="typology.Name">
                        </calibration-set-attributes>
                        <ziq-calibration-set-attributes-icons [attributesFlags]="typology" class="attributes-icons">
                        </ziq-calibration-set-attributes-icons>
                    </div>
                </ng-container>
            </div>
        </div>

        <div *cdkVirtualFor="let overlay of overlays; index as i" class="item">
            <div class="sticky">
                <div class="cell header flex around column align-center">
                    <cut-down-content length="25">{{overlay.Name}}</cut-down-content>
                    <calibration-set-attributes class="overlay-comment-icon"
                        [identifiers]="getOverlayIdentifier(overlay)"
                        [attributePopupTitleDetails]="overlay.Name">
                    </calibration-set-attributes>
                    <ziq-calibration-set-attributes-icons [attributesFlags]="overlay" class="attributes-icons">
                    </ziq-calibration-set-attributes-icons>
                </div>
                <div class="options-block header flex">
                    <div class="option">Enable</div>
                    <div class="option">Add to list</div>
                    <div class="option">Default</div>
                </div>
            </div>
            <ng-container *ngFor="let typology of overlay.OverlayTypology; let y = index">
                <div class="cell flex between" [ngClass]="{'stub': !isApplicableTypology(i, y)}"
                    matTooltip="The current Typology is not available for this Overlay"
                    [matTooltipDisabled]="isApplicableTypology(i, y)" [matTooltipPosition]="'left'">
                    <div class="boxes-block flex align-center around">
                        <div class="box" [ngClass]="{
                                        'changed': typology.isFieldChanged('IsEnabled')
                                   }">
                            <input type="checkbox" [disabled]="!isApplicableTypology(i, y)"
                                [ngModel]="typology.currentState.IsEnabled"
                                (ngModelChange)="setValue(typology, $event, 'IsEnabled')">
                        </div>
                        <div class="box" [ngClass]="{
                                        'changed': typology.isFieldChanged('IsAddedToList')
                                   }">
                            <input type="checkbox"
                                [disabled]="!typology.currentState.IsEnabled || !isApplicableTypology(i, y)"
                                [ngModel]="typology.currentState.IsAddedToList"
                                (ngModelChange)="setValue(typology, $event, 'IsAddedToList')">
                        </div>
                        <div class="box" [ngClass]="{
                                        'changed': typology.isFieldChanged('IsDefault')
                                   }">
                            <input type="checkbox"
                                [disabled]="!typology.currentState.IsAddedToList || !typology.currentState.IsEnabled || !isApplicableTypology(i, y)"
                                [ngModel]="typology.currentState.IsDefault" (ngModelChange)="setDefault($event, i, y)">
                        </div>
                        <overlay-typology-attributes class="overlay-comment-icon"
                            [beforeSaveHook]="getBeforeSave(typology.currentState.Id)"
                            [identifiers]="getOverlayTypologyIdentifier(typology.currentState)" [showPopover]="true"
                            [overlayTypology]="typology"
                            [attributePopupTitleDetails]="overlay.Name + ' - ' + typologies[y].Name">
                        </overlay-typology-attributes>
                    </div>
                </div>
            </ng-container>
        </div>
    </cdk-virtual-scroll-viewport>
</div>
